import React from 'react';
import * as Styled from './MTextBlockBasic.styles';
import { MTextBlockBasicProps, MTextBlockBasicAlignment } from './MTextBlockBasic.types';
import { AEyebrow, AEyebrowVariant } from '../../atoms/AEyebrow/index';
import { ASubheader } from '../../atoms/ASubheader/index';
import { ASubheaderSize } from '../../atoms/ASubheader/ASubheader.types';
import { ABody } from '../../atoms/ABody/index';
import { ABodySize, ABodyColor } from '../../atoms/ABody/ABody.types';

const COMPONENT_NAME = 'm-web-ui-kit-MTextBlockBasic';
const TEST_ID = 'web-ui-kit-MTextBlockBasic';

function MTextBlockBasic({
  alignment = MTextBlockBasicAlignment.Left,
  aEyebrow,
  aSubheader,
  aBody,
  ...rest
}: MTextBlockBasicProps) {
  return (
    <Styled.Wrapper data-component-name={COMPONENT_NAME} data-testid={TEST_ID} alignment={alignment} {...rest}>
      {aEyebrow?.eyebrowText && (
        <AEyebrow
          eyebrowText={aEyebrow.eyebrowText}
          variant={aEyebrow.variant || AEyebrowVariant.Primary}
          className={aEyebrow.className}
        />
      )}
      {aSubheader?.text && (
        <ASubheader
          text={aSubheader.text}
          size={aSubheader.size || ASubheaderSize.XL}
          element={aSubheader.element}
          className={aSubheader.className}
        />
      )}
      {aBody?.bodyText && (
        <ABody
          bodyText={aBody.bodyText}
          size={aBody.size || ABodySize.M}
          color={aBody.color || ABodyColor.Default}
          className={aBody.className}
        />
      )}
    </Styled.Wrapper>
  );
}

export { MTextBlockBasic, TEST_ID as M_TEXT_BLOCK_BASIC_TEST_ID };
